import { useMutation, useQueryClient } from "@tanstack/react-query";

import {
  patchActorsActorIDActorVoicesActorVoiceIDStatus,
  type UpdateActorVoiceStatusRequest,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { ACTOR_VOICES_QUERY_KEYS } from "../Queries/actorVoicesQueryKeys";
import { ACTORS_QUERY_KEYS } from "../Queries/queryKeys";

interface UpdateActorVoiceStatusParams {
  actorID: string;
  actorVoiceID: string;
  isActive: boolean;
}

export function useUpdateActorVoiceStatusMutation() {
  const queryClient = useQueryClient();

  const mutationFn = processResponse(
    ({ actorID, actorVoiceID, isActive }: UpdateActorVoiceStatusParams) => {
      const request: UpdateActorVoiceStatusRequest = { isActive };
      return patchActorsActorIDActorVoicesActorVoiceIDStatus(
        request,
        actorID,
        actorVoiceID,
      );
    },
  );

  return useMutation({
    mutationFn,
    onSuccess: (_, { actorID }) => {
      queryClient.invalidateQueries({
        queryKey: ACTORS_QUERY_KEYS.detail(actorID),
      });
      queryClient.invalidateQueries({
        queryKey: ACTOR_VOICES_QUERY_KEYS.all(actorID),
      });
    },
  });
}
